'use strict';

import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.css';

import dt from 'angular-datatables';

import 'angular-datatables/dist/plugins/buttons/angular-datatables.buttons';
import 'angular-datatables/dist/plugins/bootstrap/datatables.bootstrap.min.css';

import 'datatables.net-responsive/js/dataTables.responsive';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';

import 'datatables.net-buttons';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';

import 'datatables.net-buttons-dt/css/buttons.dataTables.css';

import DataTableComponent from '../../components/datatable/datatable.component';

/* Module */
export default angular.module('conduu.ap.datatables', [dt, DataTableComponent])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/datatables/index.js